import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 hover:text-primary-500 transition-colors"
          >
            <div className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
              <i className="ri-play-circle-fill text-lg"></i>
            </div>
            <span className="font-semibold text-lg whitespace-nowrap" style={{ fontFamily: "var(--font-heading)" }}>
              P站视频指南
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === "/"
                  ? "bg-primary-100 text-primary-700 font-medium"
                  : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? "bg-primary-100 text-primary-700 font-medium"
                    : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === "/about"
                  ? "bg-primary-100 text-primary-700 font-medium"
                  : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 hover:text-foreground-950 transition-colors"
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${isMobileMenuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className={`px-4 py-2.5 text-sm rounded-lg transition-colors ${
                location.pathname === "/"
                  ? "bg-primary-100 text-primary-700 font-medium"
                  : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2.5 text-sm rounded-lg transition-colors ${
                  location.pathname === `/category/${cat.slug}`
                    ? "bg-primary-100 text-primary-700 font-medium"
                    : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2.5 text-sm rounded-lg transition-colors ${
                location.pathname === "/about"
                  ? "bg-primary-100 text-primary-700 font-medium"
                  : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}